import { Input } from "semantic-ui-react"

const ShortText = ({ field, fieldValue = "", updateIdea, isEditing }) => {
  if (!isEditing) return <span>{fieldValue}</span>
  return (
    <div>
      <Input
        fluid
        value={fieldValue}
        onChange={(e) => updateIdea(e.target.value, ["templated", field.id])}
        readOnly={!isEditing}
      />
    </div>
  )
}

export default ShortText
